import { ReactNode } from "react";

const Title = ({ title }: { title: ReactNode }) => (
  <div className="text-lg font-medium">{title}</div>
);

export default Title;
